<!--
 * @Author:MX
 * @Date: 2020-08-03 11:36:59
 * @LastEditTime: 2024-05-30 16:26:25
 * @Description: 服务管理-运费查询
-->
<template>
  <div class="freightInquiryContent main-wrap">
      <div class="form">
          <el-form :rules="rules" class="el-form-edit" :inline="true" :model="searchParam" ref="searchParam" label-position="left" label-suffix=" :">
               <el-col :span="4">
                   <!-- <el-form-item :label="$lang('寄件城市')" prop="senderCity">
                      <BaseAddress ref="senderProvinceSearch" :showLevel="3" v-model="searchParam.senderCity" @changeValue="changeValue"> </BaseAddress>
                  </el-form-item> -->
                <el-form-item :label="$lang('寄件邮编')" id="areaCodeSty" prop="senderPostalCode">
                   <el-input v-model.trim="searchParam.senderPostalCode" :minlength="1" :maxlength="5" @input='postalCodeOnInput(searchParam.senderPostalCode, 1, "searchParam")'  @blur="postalCodeChange(searchParam.senderPostalCode, 1, 'searchParam')"></el-input>
                </el-form-item>
                <el-form-item :label="$lang('寄件州')" prop="senderProvinceName">
                  <el-input v-model.trim="searchParam.senderProvinceName" readonly></el-input>
                  <!-- <el-select v-model="searchParam.senderProvinceName" @change="dataProvinceChange($event, 1, 'searchParam')">
                    <el-option
                      v-for="item in provinceList"
                      :key="item.id"
                      :label="item.nativeName"
                      :value="item.id"
                    />
                  </el-select> -->
                </el-form-item>
                <el-form-item :label="$lang('寄件市')" prop="senderCityName">
                  <el-input v-model.trim="searchParam.senderCityName" readonly></el-input>
                  <!-- <el-select v-model="searchParam.senderCityName" @change="dataCityChange($event, 1, 'searchParam')">
                    <el-option
                      v-for="item in cityList"
                      :key="item.id"
                      :label="item.nativeName"
                      :value="item.id"
                    />
                  </el-select> -->
                </el-form-item>
                <el-form-item :label="$lang('寄件乡镇')" prop="senderAreaName">
                  <el-select v-model="searchParam.senderAreaName" @change="senderAreaChange($event, 1)">
                    <el-option
                      v-for="item in areaList"
                      :key="item.id"
                      :label="item.nativeName"
                      :value="item.id"
                    />
                  </el-select>
                </el-form-item>
               </el-col>
                <el-col :span="4">
                     <!-- <el-form-item :label="$lang('收件城市')" prop="reciveCity">
                         <BaseAddress ref="reciveProvinceSearch" :showLevel="3" v-model="searchParam.reciveCity" @changeValue="changeValue"> </BaseAddress>
                     </el-form-item> -->
                <el-form-item :label="$lang('收件邮编')" id="areaCodeSty" prop="receiverPostalCode">
                   <el-input v-model.trim="searchParam.receiverPostalCode" :minlength="1" :maxlength="5" @input='postalCodeOnInput(searchParam.receiverPostalCode, 2, "searchParam")'  @blur="postalCodeChange(searchParam.receiverPostalCode, 2, 'searchParam')"></el-input>
                </el-form-item>
                <el-form-item :label="$lang('收件州')" prop="receiverProvinceName">
                  <el-input v-model.trim="searchParam.receiverProvinceName" readonly></el-input>
                  <!-- <el-select v-model="searchParam.receiverProvinceName" @change="dataProvinceChange($event, 2, 'searchParam')">
                    <el-option
                      v-for="item in provinceList"
                      :key="item.id"
                      :label="item.nativeName"
                      :value="item.id"
                    />
                  </el-select> -->
                </el-form-item>

                <el-form-item :label="$lang('收件市')" prop="receiverCityName">
                  <el-input v-model.trim="searchParam.receiverCityName" readonly></el-input>
                  <!-- <el-select v-model="searchParam.receiverCityName" @change="dataCityChange($event, 2, 'searchParam')">
                    <el-option
                      v-for="item in cityList2"
                      :key="item.id"
                      :label="item.nativeName"
                      :value="item.id"
                    />
                  </el-select> -->
                </el-form-item>
                <el-form-item :label="$lang('收件乡镇')" prop="receiverAreaName">
                  <el-select v-model="searchParam.receiverAreaName" @change="senderAreaChange($event, 2)">
                    <el-option
                      v-for="item in areaList2"
                      :key="item.id"
                      :label="item.nativeName"
                      :value="item.id"
                    />
                  </el-select>
                </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item :label="$lang('产品类型')" prop="type">
                          <el-input v-model="searchParam.type" disabled></el-input>
                     </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item :label="$lang('物品重量(kg)')" prop="num">
                          <el-input-number v-model="searchParam.num" :label="$lang('描述文字')" :precision="2" style="width:100%;" @change="handleChange" :min="1" :max="30"></el-input-number>
                     </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item :label="$lang('服务方式')" prop="service">
                         <el-input v-model="searchParam.service" disabled></el-input>
                     </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item :label="$lang('结算方式')" prop="payment">
                        <!-- <Base-Select v-model="searchParam.payment" :dic="payTypesDic" :placeholder="$lang('请选择')"  :props="{label:'name' ,value:'code',valueObj:true}"></Base-Select> -->
                        <Base-Select v-model="searchParam.payment" :props="{label:'name',value:'code', res:'appPaymentMannerVOList',valueObj:true}"
                                    dicUrl="/vip/baseData/list"  :placeholder="$lang('请选择')">
                                </Base-Select>
                     </el-form-item>
                </el-col>
          </el-form>
          <div class="btns">
                <el-button type="primary" plain @click="resetSearch" class="h40 clear">{{ $lang('清空') }}</el-button>
                <el-button type="primary" @click="searchFun" :loading="loading" class="h40">{{ $lang('立即查询') }}</el-button>
          </div>

      </div>
      <h3>
          <span>{{ $lang('标准运费') }}：</span><span> {{ cost}} MXN</span>
      </h3>
  </div>
</template>

<script type="text/javascript">
import { getComCost, getSettlement } from '@api/module/customer'
import { RESPONSE_SUCCESS, DIC } from '@constants'
import { RULES } from '@utils/rules'
import address from '@/mixins/address'

export default {
  name: 'FreightInquiry',
  mixins: [address],
  data() {
    return {
      isShowFirst: false,
      loading: false,
      DIC,
      COM_HTTP: {
        reqList: getComCost,
      },
      endAddressId: '',
      startAddressId: '',
      searchParam: {
        senderCity: '',
        reciveCity: '',
        num: 1,
        type: this.$lang('标准快递'),
        service: this.$lang('派送上门'),
        payment: { code: 'PP_PM', name: this.$lang('寄付月结'), id: 7, type: 'ZD106' }, // 支付方式
        senderProvinceId: '', // 寄件省份id,
        senderProvinceName: '', // 寄件省份名称,
        senderCityId: '', // 寄件城市id,
        senderCityName: '', // 寄件城市名称,
        senderAreaId: '', // 寄件区域id,
        senderAreaName: '', // 寄件区域名称,
        receiverProvinceId: '', // 收件省份id,
        receiverProvinceName: '', // 收件省份名称,
        receiverCityId: '', // 收件城市id,
        receiverCityName: '', // 收件城市名称,
        receiverAreaId: '', // 收件区域id,
        receiverAreaName: '', // 收件区域名称,
        senderPostalCode: '',
        receiverPostalCode: '',
      },
      cost: 0,
      rules: {
        senderCity: [RULES.required],
        reciveCity: [RULES.required],
        num: [RULES.required],
        type: [RULES.required],
        service: [RULES.required],
        payment: [RULES.required],
        senderPostalCode: [RULES.required, RULES.postalCode],
        receiverPostalCode: [RULES.required, RULES.postalCode],
      },
      // payTypesDic: [{ code: 'PP_PM', name: this.$lang('寄付月结'), id: 319, type: 'ZD106' }, { code: 'PP_CASH', name: this.$lang('寄付现结'), id: 320, type: 'ZD106' }, { code: 'CC_CASH', name: this.$lang('到付现结'), id: 321, type: 'ZD106' }],
    }
  },
  created () {
    this.getProList()
  },
  watch: {
    'searchParam.senderAreaId'(val) {
      this.dataAreaChange(val, 1, 'searchParam')
    },
    'searchParam.receiverAreaId'(val) {
      this.dataAreaChange(val, 2, 'searchParam')
    },
  },
  methods: {
    handleChange() {},
    async areaChangeAfter ({ senderAreaId, senderCityId, senderProvinceId, receiverAreaId, receiverCityId, receiverProvinceId } = {}, type) {
      console.log(type, senderAreaId, senderCityId, senderProvinceId)
      let params = null
      if (type === 1 && senderProvinceId && senderCityId && senderAreaId) {
        params = {
          providerId: senderProvinceId,
          cityId: senderCityId,
          areaId: senderAreaId,
        }
      }
      if (type === 2 && receiverAreaId && receiverCityId && receiverProvinceId) {
        params = {
          providerId: receiverProvinceId,
          cityId: receiverCityId,
          areaId: receiverAreaId,
        }
      }
      if (params) {
        const { data, code, msg } = await getSettlement(params)
        if (code === RESPONSE_SUCCESS) {
          if (data) {
            type === 1 ? this.startAddressId = data.id : this.endAddressId = data.id
          }
        } else {
          this.$message.error(this.$lang(msg))
        }
      }
    },
    senderAreaChange(id, typeVal) {
      typeVal === 1 ? (this.searchParam.senderAreaId = id) : (this.searchParam.receiverAreaId = id)
    },
    getParams(endAddressId, startAddressId) {
      const id = this.searchParam.payment.id || ''
      const { senderCityId, receiverCityId } = this.searchParam
      let smModeType = 2
      if (id) {
        switch (id) {
          case 6:
            smModeType = 1
            break
          case 7:
            smModeType = 2
            break
          case 8:
            smModeType = 3
            break
        }
      }
      return {
        endAddressId: this.endAddressId,
        startAddressId: this.startAddressId,
        value: this.searchParam.num,
        smMode: smModeType,
        productTypeCode: 'EZ',
        goodsTypeCode: 'bm000012',
        startCityId: senderCityId,
        endCityId: receiverCityId
      }
    },
    // 重置搜索
    resetSearch() {
      // this.$refs.senderProvinceSearch.clearInput()
      // this.$refs.reciveProvinceSearch.clearInput()
      this.searchParam.num = 1
      this.$refs.searchParam.resetFields()
      this.cost = 0
      // this.searchParam.reciveCity = ''
      // this.searchParam.senderCity = ''
    },
    async changeValue(curData) {
      const { provinceId, cityId, areaId } = curData
      if (!areaId) return
      const { data, code, msg } = await getSettlement({ providerId: provinceId, cityId, areaId })
      if (code === RESPONSE_SUCCESS) {
        if (data) {
          const { id } = data
          if (provinceId === this.searchParam.senderCity.provinceId) { this.startAddressId = id }
          if (provinceId === this.searchParam.reciveCity.provinceId) { this.endAddressId = id }
        }
      } else {
        this.$message.error(this.$lang(msg))
      }
    },
    async searchFun() {
    //   if (this.searchParam.senderCity === '') return this.$message.warning('寄件地址不能为空')
    //   if (this.searchParam.reciveCity === '') return this.$message.warning('收件地址不能为空')
    //   if (!this.startAddressId) return this.$message.warning('找不到寄件地址对应的结算目的地区域')
    //   if (!this.endAddressId) return this.$message.warning('找不到收件地址对应的结算目的地区域')
    //   if (!this.searchParam.payment) return this.$message.warning('支付方式不能为空')
      this.$refs.searchParam.validate((valid) => {
        if (valid) {
          const newParams = { ...this.getParams() }
          this.loading = true
          this.COM_HTTP.reqList(newParams).then(res => {
            const { code, msg, data } = res
            this.loading = false
            if (code === RESPONSE_SUCCESS) {
              this.cost = data.result
              this.$message.success(this.$lang('查询成功！'))
            } else {
              this.$message.error(this.$lang(msg))
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.freightInquiryContent{
    padding: 24px;
    box-sizing: border-box;
    .form{
            background: #F7F7F9;
            border: 1px solid #EEEEEE;
            border-radius: 8px;
            padding:20px;
    }
    .btns{
        text-align: center;
        width: 100%;
        .clear{
            width: 112px;
        }
    }
    h3{
        font-size: 24px;
        text-align: center
    }
}
</style>
